import { Id } from "PFTypes";
import { StateCreator } from "zustand";

import {
  BookingEditModeStore,
  WallPlannerModeActions,
  WallPlannerModeSlice
} from "../booking_edit_mode_store.types";
import { INITIAL_WALL_PLANNER_MODE_STATE } from "../constants";

export const createWallPlannerSlice: StateCreator<
  BookingEditModeStore,
  [],
  [],
  { wallPlannerMode: WallPlannerModeSlice }
> = () => ({
  wallPlannerMode: INITIAL_WALL_PLANNER_MODE_STATE
});

export const createWallPlannerModeActions = (
  set: (fn: (state: BookingEditModeStore) => void | Partial<BookingEditModeStore>) => void
): WallPlannerModeActions => ({
  setUpdatableBookingIds: (ids: Id[]) => {
    set((state) => {
      state.wallPlannerMode.updatableBookingIds = ids;
    });
  },

  setIsLoading: (value: boolean) => {
    set((state) => {
      state.wallPlannerMode.isLoading = value;
    });
  },

  reset: () => {
    set((state) => {
      state.wallPlannerMode = INITIAL_WALL_PLANNER_MODE_STATE;
    });
  },

  setFocusedInputId: (focusedInputId) => {
    set((state) => {
      state.wallPlannerMode.focusedInputId = focusedInputId;
    });
  }
});
